if(typeof open-ask-ai/styles.css === 'undefined') { var e = new Error("Cannot find module 'open-ask-ai/styles.css'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = open-ask-ai/styles.css;